var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.674,
    height: 16.674,
    viewBox: "0 0 16.674 16.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2D7FF9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.2,11.783,12.551,10.22a.782.782,0,0,0-.912.225l-1.615,1.974A12.071,12.071,0,0,1,4.253,6.648L6.227,5.032a.78.78,0,0,0,.225-.912L4.888.473a.787.787,0,0,0-.9-.453L.606.8A.782.782,0,0,0,0,1.563,15.109,15.109,0,0,0,15.111,16.675a.782.782,0,0,0,.762-.606l.782-3.387A.791.791,0,0,0,16.2,11.783Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLogin);
export default __webpack_public_path__ + "static/media/phone-login.22e2af0ae051fbb63828b6b99355c027.svg";
export { ForwardRef as ReactComponent };